import { useMutation, useQueryClient } from '@tanstack/react-query';

import { accountApi } from '../api';

interface UseUploadUserPhotoParams {
  userId: string;
  file: File;
}

export const MAX_USER_PHOTO_BYTES = 5 * 1024 * 1024;
export const ALLOWED_USER_PHOTO_TYPES = ['image/jpeg', 'image/png', 'image/webp'];

const readFileAsBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(',')[1] ?? '');
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });

export const useUploadUserPhoto = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: async ({ userId, file }: UseUploadUserPhotoParams) => {
      const dataBase64 = await readFileAsBase64(file);
      const { data } = await accountApi.uploadUserPhoto(userId, {
        contentType: file.type,
        dataBase64,
      });
      return data as { photoUrl: string };
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['lifestack.user'] });
    },
  });

  return { uploadUserPhoto: mutation.mutateAsync, ...mutation };
};
